import React from "react";
import "./About_content.css";
import Common_title from "../../common-components/common-title/Common_title";

const About_content = () => {
  return (
    <>
      <section className="About_content_sec">
        <div className="container">
          <Common_title
            title="ABOUT US"
            subtitle="Your Ultimate One-Stop Shopping Destination"
            logo={
              process.env.PUBLIC_URL + "/assets/images/logo/geecart_logo.png"
            }
          />

          <div className="row mt-4">
            <div className="col-md-12 mx-auto">
              <div className="cont_div">
                <p className="abtcont">
                  We are more than just an online store. We are your everyday
                  shopping companion, bringing top-quality products across
                  electronics, fashion, footwear, and lifestyle straight to your
                  doorstep.
                </p>
                <p className="abtcont">
                  Founded with a vision to redefine online retail, GeeCart was
                  built to provide an effortless, transparent, and enjoyable
                  shopping experience for millions of customers.
                </p>
                <hr />

                <h5>Our Mission</h5>
                <p className="abtcont">
                  Shopping should be simple, exciting, and accessible to
                  everyone. We bridge the gap between world-class brands and
                  everyday shoppers by curating a diverse collection of
                  authentic products at prices that fit every budget.
                </p>
                <p className="abtcont">
                  From the latest high-tech gadgets to trending fashion pieces
                  and comfortable footwear, every product on our platform is
                  hand-selected to ensure quality and reliability.
                </p>

                <h5>Why Shop With Us?</h5>
                <p className="abtcont">
                  We prioritize your comfort and trust at every stage of your
                  order. Here is what makes GeeCart your go-to e-commerce
                  platform:
                </p>
                <ul className="abtcont">
                  <li>
                    <strong>100% Authentic Products.</strong> We partner
                    directly with verified manufacturers and authorized sellers
                    to guarantee genuine products every single time.
                  </li>
                  <li>
                    <strong>Unbeatable Value & Flash Deals.</strong> Enjoy
                    competitive pricing, seasonal discounts, and exclusive
                    app-only deals designed to maximize your savings.
                  </li>
                  <li>
                    <strong>Fast & Secure Delivery.</strong> Our optimized
                    logistics network ensures your purchases reach your doorstep
                    quickly, safely, and intact.
                  </li>
                </ul>

                <h5>Our Promise to You</h5>
                <p className="abtcont">
                  When you shop with us, you are supported by customer-first
                  policies every step of the way:
                </p>
                <ul className="abtcont">
                  <li>
                    <strong>Hassle-Free 7-Day Easy Returns.</strong> If
                    something isn't right, return or exchange your order with no
                    questions asked.
                  </li>
                  <li>
                    <strong>Safe & Flexible Payments.</strong> Pay your way
                    using Credit/Debit cards, UPI, digital wallets, or Cash on
                    Delivery.
                  </li>
                  <li>
                    <strong>24/7 Dedicated Support.</strong> Our customer care
                    team is always here to resolve your queries and track your
                    orders in real time.
                  </li>
                </ul>

                <p className="abtcont">
                  Thank you for choosing us as your trusted shopping partner.
                  Download our app today and experience seamless retail therapy
                  at your fingertips.
                </p>
                <p className="abtcont">
                  <strong>Welcome to the Future of Shopping!</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About_content;
